"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const MembraneClientContext = createContext({
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Integration... Remove this comment to see the full error message
  client: null
});
MembraneClientContext.displayName = "MembraneClientContext";
function useMembraneClient() {
  return useContext(MembraneClientContext);
}

export { MembraneClientContext, useMembraneClient };
